import styled from 'styled-components';

export const StyledErrorMessage = styled.p`
    margin-top: 0;
    font-size: ${({ theme }) => theme.fontSize.h6};
    font-weight: 600;
    color: ${({ theme }) => theme.color.red[40]};
`;
